<template>
  <div class="result-type-wrapper oceanUi-result-type-wrapper" :class="classes">
    <Icon class="result-icon" :class="states" :type="'store' + state"></Icon>
    <p class="result-title" :class="$platformClass">{{ title }}</p>
    <p class="opera-tips" :class="$platformClass">{{ tips }}</p>
    <slot></slot>
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['title', 'tips', 'state'],
  computed: {
    states() {
      return [this.state];
    },
  },
};
</script>

<style scoped>
.oceanUi-result-type-wrapper {
  background-repeat: no-repeat;
  background-position: top center;
}
</style>
